import Image from "next/image";
import Container from "./Container";
import Title from "./Title";
import Typo from "./Typo";
import { moveImageBox } from "../helpers/animations";
import { useEffect, useRef } from "react";

export default function PersonBlock({
  video,
  name,
  description,
  children,
  image,
  imageAlt = "",
  reversed = false,
  ...rest
}) {
  const refImage = useRef();
  const refBox = useRef();

  useEffect(() => {
    const handleScroll = () => {
      if (refImage.current && refBox.current) {
        moveImageBox(refImage, refBox);
      }
    };

    window?.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window?.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Container {...rest}>
      <section
        className={`flex flex-col md:items-center md:gap-16 md:pt-0 pb-16 md:pb-0 ${reversed ? "md:flex-row-reverse" : "md:flex-row"}`}
      >
        <div className="relative flex-1">{children}</div>
        <div className="relative w-full max-w-lg">
          <div
            className="absolute w-[60%] h-[60%] top-1/2 md:top-1/3 left-0 md:left-[-5%] bg-white shadow-lg rounded-md ease-out transition-transform duration-500"
            ref={refBox}
          />

          <div
            className="relative md:-top-48 max-w-[90%] md:max-w-none mt-10 md:mt-0 mr-0 ml-auto aspect-[52/63] md:min-h-lg    h-72 sm:h-96 md:h-full  rounded-md overflow-hidden ease-out transition-transform duration-1000 will-change-transform"
            ref={refImage}
          >
            {image && (
              <Image
                src={image}
                alt={imageAlt}
                className="w-full h-full object-cover"
              />
            )}

            {video && (
              <video
                autoPlay
                loop
                muted
                playsInline
                className="relative w-full h-full object-cover"
              >
                <source src={video} type="video/mp4" />
              </video>
            )}

            {(name || description) && (
              <header className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent text-white p-8 pt-24">
                <Title Elem="h3">{name}</Title>
                <Typo>{description}</Typo>
              </header>
            )}
          </div>
        </div>
      </section>
    </Container>
  );
}
